<p-button
  [icon]="PrimeIcons.UNDO"
  (click)="undo()"
  [disabled]="!undoPossible()"
  [class.opacity-60]="!undoPossible()"
  [text]="true"
  size="small"
  [pTooltip]="nextUndoableEvent()?.summary"
  tooltipPosition="bottom"
  showDelay="750"
  tooltipStyleClass="!max-w-none [&>.p-tooltip-text]:!whitespace-nowrap !text-sm"
/>
<p-button
  [icon]="PrimeIcons.REFRESH"
  (click)="redo()"
  [disabled]="!redoPossible()"
  [class.opacity-60]="!redoPossible()"
  [text]="true"
  size="small"
  [pTooltip]="nextRedoableEvent()?.summary"
  tooltipPosition="bottom"
  showDelay="750"
  tooltipStyleClass="!max-w-none [&>.p-tooltip-text]:!whitespace-nowrap !text-sm"
/>
<p-toast position="bottom-right" />
